import Indicator from '_core/components/Indicator'
import {FC} from 'react'

type props = {
  btnSave?: string
  onClose: () => void
  onConfirm?: () => void
  type?: 'button' | 'submit'
  disabled?: any
  btnCancel?: any
  isSubmitting?: any
  children?: React.ReactNode
}

export const OrderModalButton: FC<props> = ({
  btnSave,
  onClose,
  onConfirm,
  type,
  disabled,
  btnCancel,
  isSubmitting,
  children,
}) => {
  return (
    <div className='d-flex col gap-5 py-2'>
      <button id='btnClose' className='btn explore-btn-outline w-100' onClick={onClose}>
        {btnCancel ?? 'Cancel'}
      </button>
      {children}
      {!children && (
        <button
          id='btnSave'
          type={type ?? 'button'}
          className='btn btn-primary-active w-100'
          onClick={onConfirm}
          disabled={disabled}
        >
          {isSubmitting ? <Indicator text=' Please wait...' /> : btnSave ?? 'Confirm'}
        </button>
      )}
    </div>
  )
}
export default OrderModalButton
